import React, { createContext, useState, useContext } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
const OverlayContext = createContext(null);

const useStyles = makeStyles(theme => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  content: {
    color: '#fff',
    textAlign: 'center'
  }
}));
export const OverlayProvider = ({ children }) => {
  const classes = useStyles();

  const [overlay, setOverlay] = useState({
    open: false,
    component: null,
    style: {} // NEW: optional style override
  });

  return (
    <OverlayContext.Provider value={{ overlay, setOverlay }}>
      {children}
      {overlay.open && (
        <Box
          className={classes.overlay}
          style={overlay.style} // apply dynamic style here
        >
          <div className={classes.content}>
            {overlay.component || (
              <Typography variant="h5">Loading...</Typography>
            )}
          </div>
        </Box>
      )}
    </OverlayContext.Provider>
  );
};

export const useOverlay = () => useContext(OverlayContext);
